import Txt, { TxtProps } from '../ui/Txt';
import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import { useCard } from './useCard';
import * as style from './Card.css';
import { fmtFullName } from '@/lib/utils/format';

export type CardTitleProps<D extends React.ElementType = 'h2'> = TxtProps<D>;

export const CardTitle = <D extends React.ElementType>({
  children,
  ...props
}: CardTitleProps<D>) => {
  const { honorific, firstName, lastName, titleComponent, title, disabled } = useCard();

  const honorificTitle = fmtFullName(honorific, firstName, lastName);
  const content = honorificTitle || title;

  return (
    <Txt
      as={titleComponent || 'h2'}
      variant="h4"
      {...mergePropsClassName(props, style.title({ disabled }))}>
      {children || content}
    </Txt>
  );
};
